import React from 'react';

class ErrorHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // report to kaui2 log error here
  }

  render() {
    // Render error handler if caught an error
    if (this.state.errorInfo) {
      return (
        <div>
          <h2 style={{ marginTop: '50px' }}>Something Went Wrong.</h2>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/js/components/ErrorHandler/index.jsx